export class EnvConfig {
  constructor(data: any) {
    this.securityTenantName = data.securityTenantName;
    this.securityClientId = data.securityClientId;
  }
  public securityTenantName: string;
  public securityClientId: string;
}
